import React from 'react';
import Styled from './styles';

interface Props {
  onClick: (event: any) => void;
  onMouseMove?: (event: any) => void;
  children: any;
  plain?: boolean;
  hovered?: boolean;
  disabled?: boolean;
  widthAuto?: boolean;
}

const ActionButton = ({ children, plain, hovered, widthAuto, ...rest }: Props) => (
  <Styled.Button plain={plain} hovered={hovered} {...rest}>
    <Styled.Container plain={plain} hovered={hovered} widthAuto={widthAuto}>
      {children}
    </Styled.Container>
  </Styled.Button>
);

export default ActionButton;
